import React, { useState, useRef } from "react";
import { useField } from "formik";
import styles from "./Select.module.scss";
import classNames from "classnames";
import { useSetSearchCityHook } from "../../../utils/hooks";

export default ({
  label,
  variant,
  options,
  isAutocomplete,
  isSimpleDropdown,
  isTypeAndDropdown,
  onAutocomplete,
  placeholder,
  saveId,
  withoutOpacity,
  errorLabel,
  inlineStyle,
  setStartData,
  setCity,
  validateSymbols,
  hideArrow,
  suppressErrorPlaceholder,
  ...props
}) => {
  const { name } = props;
  const [isOpened, setIsOpened] = useState(false);
  const [field, meta, helpers] = useField(props);
  const [fieldValue, setFieldValue] = useState("");
  const textInp = useRef(null);
  if (setCity) {
    useSetSearchCityHook(field.value, setCity);
  }
  function handleClick() {
    textInp.current.focus();
  }
  const onChangeHandler = (value) => {
    onAutocomplete(value);
    setFieldValue(value);
    setIsOpened(true);
  };
  const handleOnBlurDiv = () => {
    if ((label === "Phone number" || name === "countryCode") && setStartData && (meta.error || !field.value)) {
      helpers.setValue("+");
      setStartData();
    } else helpers.setTouched(name);
    setIsOpened(false);
  };
  const noOpacity =
    (meta.touched && meta.error && withoutOpacity) || !isOpened
      ? styles.placeHolderNoOpacity
      : "";
  const onChange = ({ target: { value } }) => {
    if (onAutocomplete) onAutocomplete(value);
    let val = value;
    if (validateSymbols) val = validateSymbols(val);
    (label === "Phone number" || name === "countryCode") && val[0] !== "+"
      ? helpers.setValue(`+${val}`)
      : helpers.setValue(value);
    setIsOpened(true);
  };
  return (
    <>
      <div
        className={`${styles.Select} select_${name}`}
        invalid={meta.touched ? meta.error : undefined}
        variant={variant}
        opened={`${isOpened}`}
        onClick={() => setIsOpened(!isOpened)}
        style={inlineStyle ? inlineStyle : null}
        onBlur={handleOnBlurDiv}
      >
        {isAutocomplete &&
        !isTypeAndDropdown &&
        !isSimpleDropdown &&
        !errorLabel ? (
          <input
            className={classNames(styles.label, `select_${name}`, noOpacity)}
            type="text"
            value={field.value || ""}
            ref={textInp}
            onClick={handleClick}
            onChange={onChange}
            placeholder={
              isOpened
                ? "Type here..."
                : meta.touched && meta.error && !suppressErrorPlaceholder
                ? meta.error
                : placeholder
            }
          />
        ) : isAutocomplete &&
          !isTypeAndDropdown &&
          !isSimpleDropdown &&
          errorLabel ? (
          <>
            <input
              className={classNames(styles.label, `select_${name}`, noOpacity)}
              type="text"
              value={field.value || ""}
              ref={textInp}
              onClick={handleClick}
              onChange={({ target: { value } }) => {
                onAutocomplete(value);
                (label === "Phone number" || name === "countryCode") && value[0] !== "+"
                  ? helpers.setValue(`+${value}`)
                  : helpers.setValue(value);
                setIsOpened(true);
              }}
              placeholder={
                isOpened
                  ? "Type here..."
                  : meta.touched && meta.error && !suppressErrorPlaceholder
                  ? meta.error
                  : placeholder
              }
            />
            <span className={styles.label}>
              {meta.value && meta.touched ? meta.error : ""}
            </span>
          </>
        ) : isSimpleDropdown ? (
          <input
            className={classNames(styles.label, `select_${name}`, noOpacity)}
            type="text"
            value={fieldValue}
            ref={textInp}
            onClick={handleClick}
            onChange={({ target: { value } }) => {
              setFieldValue(value);
              helpers.setValue(value);
              setIsOpened(true);
            }}
            placeholder={meta.touched && meta.error ? meta.error : placeholder}
          />
        ) : isAutocomplete && isTypeAndDropdown && !saveId ? (
          <input
            className={classNames(styles.label, `select_${name}`, noOpacity)}
            type="text"
            value={field.value || ""}
            ref={textInp}
            
            onClick={handleClick}
            onKeyDown={()=>{
              setIsOpened(false)
            }}
            onChange={({ target: { value } }) => {
              if (!setCity && onAutocomplete) onAutocomplete(value);
              helpers.setValue(value);
              setIsOpened(true);
            }}
            placeholder={
              meta.touched && meta.error && !suppressErrorPlaceholder
                ? meta.error
                : placeholder
            }
          />
        ) : isAutocomplete && isTypeAndDropdown && saveId ? (
          <input
            className={classNames(styles.label, `select_${name}`, noOpacity)}
            type="text"
            value={fieldValue}
            ref={textInp}
            onClick={handleClick}
            onChange={({ target: { value } }) => onChangeHandler(value)}
            placeholder={
              meta.touched && meta.error && !suppressErrorPlaceholder
                ? meta.error
                : placeholder
            }
          />
        ) : (
          <span className={styles.label}>
             {meta.touched && meta.error 
              ? meta.error 
              : (() => {
                  if (!field.value) return placeholder || label;
                  const selectedOption = options?.find((opt) => {
                      const val = opt.value || opt.name || opt.label;
                      return String(val) === String(field.value);
                  });
                  return selectedOption ? (selectedOption.label || selectedOption.name || selectedOption.value) : field.value;
                })()
             }
          </span>
        )}

        {!hideArrow && (
          <svg
            className={styles.arrow}
            xmlns="http://www.w3.org/2000/svg"
            width="6"
            height="3.5"
            viewBox="0 0 6 3.5"
            fill="none"
          >
            <path
              d="M1.5 1L3 2.5L4.5 1"
              stroke={
                variant === "outlined"
                  ? meta.touched && meta.error
                    ? "var(--tomato)"
                    : "var(--white)"
                  : variant === "voucher"
                  ? "#000000"
                  : meta.touched && meta.error
                  ? "var(--tomato)"
                  : "var(--black)"
              }
              strokeWidth="0.3"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
        {options?.length !== 0 && (
          <div className={styles.optionsWrapper}>
            <div className={styles.options}>
              {options.map((data, index) => {
                const { value, name, label } = data;
                // Prioritize value/name for saving
                const saveValue = value || name || label;
                // Prioritize label for display
                const displayValue = label || name || value;

                return (
                  <div
                    key={index}
                    className={styles.option}
                    onMouseDown={(e) => {
                      if (onAutocomplete) onAutocomplete(saveValue);
                      setFieldValue(saveValue);
                      helpers.setValue(String(saveValue));
                      setIsOpened(false);
                    }}
                  >
                    {displayValue}
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
      {variant === "outlined" && <div className={styles.overlay} />}
    </>
  );
};
